'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropTypeBnIsRequired = exports.PropTypeBn = undefined;

var _web3Utils = require('web3-utils');

var _web3Utils2 = _interopRequireDefault(_web3Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PropTypeBn = exports.PropTypeBn = function PropTypeBn(props, propName, componentName) {
  if (props[propName] && !_web3Utils2.default.BN.isBN(props[propName])) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Validation failed.');
  }
  return null;
};

var PropTypeBnIsRequired = exports.PropTypeBnIsRequired = function PropTypeBnIsRequired(props, propName, componentName) {
  if (!props[propName]) {
    return new Error('`' + propName + '` is a required prop for `' + componentName + '`.');
  }
  if (props[propName] && !_web3Utils2.default.BN.isBN(props[propName])) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Validation failed.');
  }
  return null;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/utilities/PropTypeBn.js
// module id = 98
// module chunks = 0